import React from 'react'
import { ResponsiveLayout } from 'containers'
import { ArchivedWithRollout } from './ArchivedWithRollout'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useArchiveToFilter from 'utils/hooks/useArchiveToFilter'

const Archived = () => {
  const { enabled, isLoading } = useArchiveToFilter()
  const { t } = useTranslation()
  if (isLoading) {
    return (
      <ResponsiveLayout
        content={<div role="status">{t('general.loading')}</div>}
      />
    )
  }
  if (enabled) return <Navigate replace to="/releases?archived=true" />
  return (
    <ResponsiveLayout
      contentContainerStyles={{ overflow: 'hidden' }}
      content={<ArchivedWithRollout />}
    />
  )
}

export default Archived
